module.exports = __webpack_public_path__ + "img/coach_ceping47.a7c7650a.jpg";